module.exports = __webpack_public_path__ + "assets/img/16.bf904ff6.png";